import React from "react";

import { ReactComponent as ExternalLink } from "assets/images/external-link.svg";

import Header from "components/atoms/Header";

import LoginTheme from "themes/LoginTheme";

import { useToast } from "hooks/Toast";
import { useParams } from "react-router-dom";
import { useUpgradeUserPlanMutation } from "generated/graphql";

import { loadStripe } from "@stripe/stripe-js";
import { useStripe, Elements } from "@stripe/react-stripe-js";
import {
  ButtonsWrapper,
  HeaderWrapper,
  PriceLine,
  AdditionalInfo,
  StyledButton,
  Container,
} from "./styles";
import { UpgradeType } from "./types";

const PaymentContent = ({ type }: { type: UpgradeType }) => {
  const stripe = useStripe();
  const Toast = useToast();
  const [upgradeUserPlan] = useUpgradeUserPlanMutation();

  const handlePay = () => {
    upgradeUserPlan({
      variables: {
        type: type.replace("-add-on", ""),
      },
    })
      .then((sessionIdData) => {
        if (stripe && sessionIdData.data) {
          const sessionId = sessionIdData.data.upgradeUserPlan;

          if (sessionId) {
            stripe.redirectToCheckout({
              sessionId,
            });
          }
        }
      })
      .catch((error) => {
        Toast("error", error.message || "errorAction.generalError");
      });
  };

  const packageDetails = (packageType: string) => {
    switch (packageType) {
      case UpgradeType.ESSENTIAL:
        return {
          price: 65,
          description: "CareerFit Essentials",
        };
      case UpgradeType.CLARITY:
        return {
          price: 195,
          description: "CareerFit Clarity",
        };
      case UpgradeType.CLARITY_ADD_ON:
        return {
          price: 130,
          description: "CareerFit Clarity",
        };
      case UpgradeType.GUIDANCE:
        return {
          price: 315,
          description: "CareerFit Guidance",
        };
      case UpgradeType.GUIDANCE_ADD_ON:
        return {
          price: 250,
          description: "CareerFit Guidance",
        };
      default:
        return { price: 65, description: "CareerFit Essentials" };
    }
  };

  return (
    <LoginTheme selfRegistration narrow>
      <Container>
        <HeaderWrapper>
          <Header>Finalise your account </Header>
        </HeaderWrapper>
        <PriceLine>
          <div>{packageDetails(type).description}</div>
          <div>{packageDetails(type).price} €</div>
        </PriceLine>
        <AdditionalInfo>
          To begin the assessments and get your personalised report, please
          finalise your account via Stripe using the button below.
        </AdditionalInfo>
        <ButtonsWrapper style={{ width: "20rem" }}>
          <StyledButton variant="primary" onClick={handlePay}>
            Pay with Stripe <ExternalLink />
          </StyledButton>
        </ButtonsWrapper>
      </Container>
    </LoginTheme>
  );
};

const Payment = () => {
  const stripeLoader = loadStripe(process.env.REACT_APP_STRIPE_TEST_KEY || "");
  const { type } = useParams<{ type: UpgradeType }>();
  return (
    <Elements stripe={stripeLoader}>
      <PaymentContent type={type || "essentials"} />
    </Elements>
  );
};

export default Payment;
